import React, {useEffect} from "react"
import { useParams } from "react-router-dom"
import { Plus, Database, Tags, CircleUser } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn, randoms } from "lib/utils"
import { Modal, TagsManager, ClientDataManager } from "lib/components"
import { ConditionalStatementButton, SectionTitle, useConditional, useClipboard } from "lib/units/conditional"
import {useConditionalCtx} from "lib/units/dispute/statements/conditionals"

export default function ConditionalClipboard({ }:{ }){ 
  
  const { tmplid } = useParams()
  const { appState }:any = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { openModal, putItemInSpotlight, closeModal }:any = useConditional()  
  const { addTagToClipboard, clipboardItemIsReady, getQueryableTags }:any = useClipboard()

  const { currentConditional, updateConditional }:any = useConditionalCtx()

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })

  const titleClasses = "block px-3 bg-slate-900 text-xs absolute top-[-9px] left-4 uppercase flex items-center gap-3"
  const remoteTitleClasses = "w-full relative left-auto top-auto bg-transparent border border-solid border-slate-800 py-1"

  // useEffect(() => {
  //   console.log(currentConditional?.clipboard)
  // },[currentConditional?.clipboard])

  return (
    <div className="w-full h-[8rem] h-full flex justify-start items-start border border-solid border-slate-700 relative">

      <Modal status={store.metas.conditionalModal === "tags" ? "open" : "closed"} size="md" rotate={false} title="Tags" onClose={closeModal} showCloseBtn={true}>
        <TagsManager 
          className="h-full" 
          lookups={{ template: _Template?._id, client: _Template?.AssignedTo?._id || null }}
          types={["client", "template", "single-client"]} 
          selectFn={addTagToClipboard}  
        />
      </Modal>

      <Modal status={store.metas.conditionalModal === "client" ? "open" : "closed"} size="md" rotate={false} title="Client Data" onClose={closeModal} showCloseBtn={true}>
        <ClientDataManager 
          className="h-full" 
          tagsOwned={getQueryableTags()} 
          ownerTypes={["client", "template"]} 
          selectFn={addTagToClipboard}  
        />
      </Modal>

      <div className="w-[97%] absolute top-[-12px] left-3 text-xs flex justify-between items-center">
        <div className="pl-2 pr-4 bg-[#161922]">query elements</div>
        <div className="flex justify-end items-center gap-2 mt-[-3px]">
          <Database className="w-7 h-7 cursor-pointer stroke-1 bg-slate-700 border border-solid border-slate-800 rounded-full p-1" onClick={() => openModal("apidata")} />
          <Tags className="w-7 h-7 cursor-pointer stroke-1 bg-slate-700 border border-solid border-slate-800 rounded-full p-1" onClick={() => openModal("tags")} />
          <CircleUser 
            className="w-7 h-7 cursor-pointer stroke-1 bg-slate-700 border border-solid border-slate-800 rounded-full p-1" 
            onClick={() => console.log(currentConditional)} 
            // onClick={() => openModal("client")} 
          />
        </div>
      </div>



      <div className="w-full h-full flex justify-start items-start flex-wrap gap-2 py-4 px-6">
        {currentConditional?.clipboard?.map( (item:any, idx:number) => (
          <ConditionalStatementButton 
            key={idx} 
            item={item}
            location="clipboard"
            draggable={clipboardItemIsReady(item) || item.operator === "mustExist"}
            spotlight={item.refid === store.metas.conditionalSpotlight ? "true" : "false" }
            onClick={() => putItemInSpotlight({ item, location: "clipboard" })}  
          />
        ))}
      </div>

      {/* <div className="absolute bottom-0 right-0 p-1 pr-3 flex gap-2 flex flex-col">
        <div className="flex justify-end items-center gap-2">
          <ConditionalStatementButton  
            key="auto-pass"
            item={{ refid: randoms.string(12,"a#"), source: "automatic", value: "pass", location: "clipboard" }}
            location="clipboard"
            draggable={true}
            spotlight="false"
            onClick={() => putItemInSpotlight({ refid: "auto-pass", source: "automatic", value: "pass", location: "clipboard" }) }
            />
          <ConditionalStatementButton  
            key="auto-fail"
            item={{ refid: randoms.string(12,"a#"), source: "automatic", value: "fail", location: "clipboard" }}
            location="clipboard"
            draggable={true}
            spotlight="false"
            onClick={() => putItemInSpotlight({ refid: "auto-fail", source: "automatic", value: "fail", location: "clipboard" })}  
          />
        </div>
        <p className="text-[.65rem]">Warning: these selections wipe out all existing choices for this conditional group.</p>
      </div> */}
    </div>
  ) 
}